import React from "react";
import { Reveal, SectionHeading } from "./_shared";

/**
 * "The problem" – three symptomatic cards, editorial layout.
 */
const cards = [
    {
        title: "Informazioni frammentate",
        text: "Dati di aziende, sedi, lavoratori e adempimenti vengono spesso conservati in strumenti differenti.",
        color: "sky",
        num: "01",
    },
    {
        title: "Scadenze difficili da monitorare",
        text: "Formazione, visite mediche, sopralluoghi e documenti hanno tempi e responsabilità diverse.",
        color: "peach",
        num: "02",
    },
    {
        title: "Poca visibilità sulle priorità",
        text: "Senza una panoramica unica è difficile capire immediatamente cosa richiede attenzione.",
        color: "cream",
        num: "03",
    },
];
const bg = { sky: "#E4ECFD", peach: "#FDE3DD", cream: "#FBF3D4" };
const fg = { sky: "#1B4CE0", peach: "#B12D2D", cream: "#8C6E14" };

export default function Problem() {
    return (
        <section id="problema" className="relative py-24 md:py-32 bg-white">
            <div className="max-w-[1400px] mx-auto px-5 md:px-8">
                <SectionHeading
                    chapter={1}
                    chapterLabel="Il contesto"
                    title={
                        <>
                            Scadenze, documenti ed email:{" "}
                            <span className="text-navy-400">quanto è difficile tenere tutto sotto controllo?</span>
                        </>
                    }
                />
                <Reveal delay={0.15}>
                    <p className="max-w-2xl text-navy-600 text-lg leading-relaxed mt-6">
                        La gestione della sicurezza aziendale coinvolge numerose attività, persone e scadenze.
                        Quando le informazioni sono distribuite tra fogli Excel, email, documenti e calendari,
                        diventa difficile individuare rapidamente le priorità.
                    </p>
                </Reveal>

                <div className="grid md:grid-cols-3 gap-5 md:gap-7 mt-14">
                    {cards.map((c, i) => (
                        <Reveal key={c.title} delay={0.15 + i * 0.1}>
                            <article
                                data-testid={`problem-card-${i}`}
                                className="rounded-3xl p-7 md:p-8 h-full border border-navy-100 relative overflow-hidden hover-lift bg-white"
                            >
                                <div
                                    className="absolute -top-10 -right-10 w-40 h-40 rounded-full blur-2xl opacity-70"
                                    style={{ background: bg[c.color] }}
                                />
                                <div className="relative">
                                    <div className="font-mono text-xs font-semibold" style={{ color: fg[c.color] }}>
                                        — {c.num}
                                    </div>
                                    <h3 className="mt-5 font-display font-bold text-navy-950 text-2xl leading-snug">{c.title}</h3>
                                    <p className="mt-3 text-navy-600 text-[15px] leading-relaxed">{c.text}</p>
                                </div>
                            </article>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
